<script setup lang="ts">
import ModalRenderer from '@tix/modal/ModalRenderer.vue'
</script>

<template>
  <Suspense>
    <router-view />
  </Suspense>
  <ModalRenderer />
</template>
